import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { styled } from '@mui/system'

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  color: theme.palette.text.highEmphasis,
  '& th:first-of-type': {
    borderRadius: '8px 0 0 8px',
  },
  '& td:first-of-type': {
    borderRadius: '8px 0 0 8px',
  },
  '& th:last-child': {
    borderRadius: '0 8px 8px 0',
  },
  '& td:last-child': {
    borderRadius: '0 8px 8px 0',
  },
}))

export const StyledTableStickyHead = styled(StyledTableHead)(({ theme }) => ({
  position: 'sticky',
  top: '56px',
  zIndex: 100,
}))

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  border: 'none',
  backgroundColor: theme.palette.background.elevation9,
  fontWeight: 700,
  color: theme.palette.text.highEmphasis,
  top: '14px',
  padding: '6px 8px',
}))

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: 'none',
  top: '60px',
  '&.left': {
    borderRadius: '8px 0 0 8px',
  },
  '&.right': {
    borderRadius: '0 8px 8px 0',
  },
  padding: '6px 8px',
}))

export const StyledTableCellRound = styled(TableCell)(({ theme }) => ({
  border: 'none',
  borderRadius: '8px',
}))

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'isTogglable',
})<{ isTogglable?: boolean }>(({ isTogglable, theme }) => ({
  height: '32px',
  border: 'none',
  transition: 'all ease-in-out 150ms',
  '&.open': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.mainContrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.mainHover,
    },
    ':focus': {
      backgroundColor: theme.palette.primary.mainHover,
    },
  },
  '&:hover': {
    backgroundColor: isTogglable && theme.palette.background.elevation2,
    color: isTogglable && theme.palette.text.highEmphasis,
  },
  ':focus': {
    backgroundColor: isTogglable && theme.palette.background.elevation2,
    color: isTogglable && theme.palette.text.highEmphasis,
  },
  '&.selected': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.lightContrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.lightHover,
    },
    ':focus': {
      backgroundColor: theme.palette.primary.lightHover,
    },
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    ':focus': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  '&.weekend': {
    '&:not(.selected)': {
      backgroundColor: theme.palette.background.elevation2,
      '&:hover': {
        backgroundColor: isTogglable && theme.palette.background.elevation9,
      },
      ':focus': {
        backgroundColor: isTogglable && theme.palette.background.elevation9,
      },
    },
  },
}))

export const StickyTableLeftCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  left: 0,
  backgroundColor: theme.palette.background.main,
  zIndex: 1,
  borderBottom: '1px solid',
  borderColor: theme.palette.background.elevation8,
}))

export const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
  '.MuiTableSortLabel-icon': {
    margin: 0,
  },
  ':focus': {
    '.MuiTableSortLabel-icon': {
      color: theme.palette.text.highEmphasis,
      opacity: 1,
    },
    borderRadius: '4px',
    outlineWidth: '4px',
    outlineStyle: 'solid',
    outlineOffset: '-1px',
    outlineColor: theme.palette.background.elevation9,
    backgroundColor: theme.palette.background.elevation9,
  },
  '&:hover': {
    '.MuiTableSortLabel-icon': {
      color: theme.palette.text.highEmphasis,
      opacity: 0.5,
    },
    opacity: 0.5,
  },
}))
